<template>
    <div class="node-info-container">

        <div class="refresh-btn" @click="onRefresh">刷新</div>

        <div class="health-check-label-header">节点在线报告</div>
        <div class="health-check-label">更新时间：{{ nodeReportUpdateTime }}</div>
        <div class="health-check-label">总连接数：{{ totalIpConnectCount }}</div>
        <div class="health-check-label">活跃节点数：{{ activeNodeCount }}</div>
        <div class="health-check-label">失连节点数：{{ lostNodeCount }}</div>

        <div class="health-check-label" v-if="lostNodeCount > 0">失连节点：</div>
        <template v-for="item in lostNodeList" :key="item.hostName">
            <div class="test-result-lost-node">
                {{ item.hostName }}
            </div>
        </template>

        <div class="health-check-label-header">节点真延时报告</div>
        <div class="health-check-label">总测试节点数：{{ totalLatencyTestCount }}</div>
        <div class="health-check-label">
            总超时节点数：{{ allTimeoutNodes.length }}
        </div>
        <template v-if="allTimeoutNodes.length > 0">
            <div v-for="item in allTimeoutNodes" :key="item.hostName" class="test-result-lost-node">
                {{ item.hostName }}
            </div>
        </template>
        <div class="health-check-label">测速时间：{{ latencyTestReports.sg?.createTimeString }}</div>
        <div class="health-check-label">测速耗时：{{ latencyTestReports.sg?.testDuration / 1000 }}s</div>


        <template v-for="report in nodeAnalysisReports" :key="report?.recordId">
            <template v-if="report">
                <div class="health-check-label-header">{{ getNodeAnalysisReportTitle(report?.duration) }}</div>
                <div class="health-check-label">报告时间：{{ report?.createTimeString }}</div>

                <div class="health-check-label">--------------------------------------------</div>
                <template v-if="report?.content && Array.isArray(report?.content) && report?.content?.length > 0">
                    <div v-for="item in report?.content" :key="item._id">
                        <div class="health-check-label">区域：{{ getRegionLabel(item.region) }}</div>
                        <div class="health-check-label">节点类型：{{ getNodeTypeLabel(item.nodeType) }}</div>
                        <div class="health-check-label">平均在线节点数：{{
                                parseFloat(item.avgNodeCount).toFixed(2)
                            }}
                        </div>
                        <div class="health-check-label">
                            节点平均连接IP数：{{ parseFloat(item.connectIpsPerNode).toFixed(2) }}
                        </div>
                        <div class="health-check-label">节点平均连接数：{{
                                parseFloat(item.connectionsPerNode).toFixed(2)
                            }}
                        </div>
                        <div class="health-check-label">--------------------------------------------</div>
                    </div>
                </template>
            </template>

        </template>
    </div>
</template>
<script>
import {getRequestAsync, hideLoading, showLoading} from "@/utils/methods";

const REGIONS = ['sg', 'hk', 'jp', 'kor', 'us'];

const REGION_LABELS = {
    hk: '香港',
    sg: '新加坡',
    jp: '日本',
    kor: '韩国',
    us: '美国'
};

const DURATION_LABELS = {
    '24h': '过去24小时',
    '7d': '过去7天',
    '14d': '过去14天',
    '30d': '过去30天'
};

export default {
    name: "NodeInfoView",
    components: {},
    data() {
        return {
            activeNodeCount: 0,
            lostNodeCount: 0,
            nodeReportUpdateTime: null,
            lostNodeList: [],
            totalIpConnectCount: 0,
            nodeAnalysisReports: [],
            latencyTestReports: {},
            totalLatencyTestCount: -1,
            latencyTimeoutNodes: {},
        }
    },
    computed: {
        allTimeoutNodes() {
            return REGIONS.flatMap(r => this.latencyTimeoutNodes[r] || []);
        }
    },
    async mounted() {
        this.getNodeSummarize()
    },
    methods: {
        async getNodeSummarize() {
            showLoading()
            const result = await getRequestAsync('admin/stats/getNodeConnectionSummarize')
            hideLoading()
            if (result?.code === 200 && result?.msg) {
                this.activeNodeCount = result.msg.nodeSummarizeReport?.activeNodesCount
                this.lostNodeCount = result.msg.nodeSummarizeReport?.missingNodesCount
                this.nodeReportUpdateTime = result.msg.nodeSummarizeReport?.createTimeString
                this.lostNodeList = result.msg.nodeSummarizeReport?.missingNodeSummarize
                this.totalIpConnectCount = result.msg.nodeSummarizeReport?.totalConnectedIpCount
                this.nodeAnalysisReports = result.msg.nodeAnalysisReports

                const reports = {};
                const timeoutNodes = {};
                let totalCount = 0;

                for (const region of REGIONS) {
                    const key = `nodeLatencyTest${region.charAt(0).toUpperCase() + region.slice(1)}`;
                    const report = result.msg[key];
                    reports[region] = report;
                    timeoutNodes[region] = report?.result?.filter(item => item.latency < 0) || [];
                    totalCount += report?.result?.length || 0;
                }

                this.latencyTestReports = reports;
                this.latencyTimeoutNodes = timeoutNodes;
                this.totalLatencyTestCount = totalCount;
            }
        },
        async onRefresh() {
            await this.getNodeSummarize()
        },
        getNodeAnalysisReportTitle(type) {
            return DURATION_LABELS[type] || ''
        },
        getRegionLabel(region) {
            return REGION_LABELS[region] || region
        },
        getNodeTypeLabel(nodeType) {
            if (nodeType === 'general') {
                return '通用'
            }
        }
    }

}
</script>

<style scoped>

.node-info-container {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: start;
}

.health-check-label {
    text-align: start;
    color: #E6D5B8;
    font-size: 1em;
}

.health-check-label-header {
    text-align: start;
    color: #E6D5B8;
    font-size: 1em;
    font-weight: bold;
    margin-top: 0.4em;
}

.test-result-lost-node {
    width: 100%;
    box-sizing: border-box;
    font-size: 1em;
    text-align: start;
    word-break: break-all;
    color: red;
}

.refresh-btn {
    color: #E6D5B8;
    border: 1px solid #E6D5B8;
    padding: 0.2em 0.4em;
    font-size: 1.2em;
    line-height: 1em;
    height: fit-content;
    border-radius: 0.2em;
    cursor: pointer;
    margin-bottom: 0.4em;
    width: fit-content;
}

</style>